module.exports = __webpack_public_path__ + "static/img/aboutUs-img-b.8b67402.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutUs-img-b.jpg
// module id = I6l0
// module chunks = 1